import { SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { useEffect, useState } from "react";
import useIsMounted from "ismounted";
import { notifyMessage } from "../../common/notifyMessage";

interface PropsInterface {
  notificationMessage?: string;
  styles?: React.CSSProperties;
  successClassName?: string;
  failureClassName?: string;
  warningClassName?: string;
  closeButtonPresent?: boolean;
  onDismiss?: (type: string) => void;
}

const SuccessAndErrorMessage = (props: PropsInterface) => {
  const { notificationMessage, successClassName, failureClassName, warningClassName } = props;
  const [onClose, setOnClose] = useState<boolean>();
  const isMounted = useIsMounted();
  const handleClose = () => {
    setOnClose(false);
  };
  useEffect(() => {
    setOnClose(true);
  }, [onClose]);

  useEffect(() => {
    if (isMounted) {
      if (!notificationMessage) {
        notifyMessage(successClassName || "successMessage", 0);
        notifyMessage(failureClassName || "errorMessage", 0);
        notifyMessage(warningClassName || "warningMessage", 0);
      }
    }
  }, [notificationMessage]);

  return (
    <>
      {onClose && (
        <div
          id={successClassName ? successClassName : "successMessage"}
          className="hidden"
        >
          <SkyMessageBar
            intent="success"
            message={notificationMessage || ""}
            onDismiss={handleClose}
          />
        </div>
      )}
      {onClose && (
        <div
          id={failureClassName ? failureClassName : "errorMessage"}
          className="hidden"
        >
          <SkyMessageBar
            intent="error"
            message={notificationMessage || ""}
            onDismiss={handleClose}
          />
        </div>
      )}
      {onClose && (
        <div
          id={warningClassName ? warningClassName : "warningMessage"}
          className="hidden"
        >
          <SkyMessageBar
            intent="warning"
            message={notificationMessage || ""}
            onDismiss={handleClose}
          />
        </div>
      )}
    </>
  );
};

export default SuccessAndErrorMessage;
